module.exports = __webpack_public_path__ + "assets/img/22_216_big.a9ac5e42.jpg";